import React from "react";
import { useLanguage } from "@/contexts/LanguageContext";
import { getCategoryTailwindColor } from "../utils/categoryColors";
import { CategoryType } from "../types/category";

interface CategoryBadgeProps {
  category: CategoryType;
  size?: "xs" | "sm" | "md" | "lg";
}

const CategoryBadge = ({ category, size = "md" }: CategoryBadgeProps) => {
  const { t } = useLanguage();

  // Get the translated category name using the translation key
  const translationKey = `categories.${category}`;
  const displayName = t(translationKey) || category;

  // Determine text size based on size prop
  let textSize = "text-xs";
  let padding = "px-2 py-1";

  if (size === "xs") {
    textSize = "text-[10px]";
    padding = "px-1.5 py-0.5";
  } else if (size === "sm") {
    textSize = "text-xs";
    padding = "px-1.5 py-0.5";
  } else if (size === "lg") {
    textSize = "text-sm";
    padding = "px-2.5 py-1.5";
  }

  return (
    <span
      className={`${padding} rounded-full ${textSize} font-medium border ${getCategoryTailwindColor(category)}`}
    >
      {displayName}
    </span>
  );
};

export default CategoryBadge;
